import {AppLocale} from "../../../src/Register/RegisterLanguage";
import React from 'react';
import {replaceHTMLTag, PreperatorReplace} from "../helper/index"

const IntlMessage = (props) => {


    let languageFile;

    if (AppLocale[props.locale] !== undefined) {
        languageFile = AppLocale[props.locale]?.messages;

        /**
         *  Falls vorhanden wird der Language string entnommen.
         */

        let messageValue = languageFile[props.messageId]

        switch (props.preperator) {
            case 'replace':
                messageValue = PreperatorReplace(messageValue, props.param, props.replacement)
                break;
        }

        if (messageValue === undefined) {
            messageValue = props.messageId
        }
        if (props.htmlReplace !== undefined && props.htmlReplace === true) {
            messageValue = replaceHTMLTag(messageValue);
        }
        return (messageValue);


    }
    return props.messageId;


}
export default IntlMessage;





